import { FETCH_USERS, INVITE_USER, REVOKE_INVITE, REVOKE_USER, UPDATE_USER_ROLE } from '@/store/types/actions';
import { INVITES_FETCHED, INVITE_REVOKED, USERS_FETCHED, USER_REVOKED, USER_ROLE_UPDATED } from '@/store/types/mutations';
import { ACCOUNT, ROLE } from '@/store/types/namespaces';
import { apolloSdk } from '../../api/apollo';

// getters
const getters = {
  users: (state) => state.users,
};

// actions
const actions = {
  async [FETCH_USERS]({ commit, rootState }) {
    const accountId = rootState[ROLE].currentAccount.id;
    const response = await apolloSdk.Users({ accountId });
    const { users, invites } = response.node;
    commit(USERS_FETCHED, users);
    commit(INVITES_FETCHED, invites);
  },
  async [REVOKE_USER]({ commit, rootState }, { userId }) {
    const accountId = rootState[ACCOUNT].id;
    const response = await apolloSdk.RevokeUser({ nodeId: accountId, userId });
    const { errors } = response.revokeUser;
    if (errors && errors.length > 0) {
      return Promise.reject(errors[0].message);
    }
    return commit(USER_REVOKED, userId);
  },
  async [UPDATE_USER_ROLE]({ rootState, commit }, {
    userId,
    level,
    scopeId = null,
    version,
  }) {
    const accountId = rootState[ACCOUNT].id;
    const input = {
      userId,
      level: scopeId ? 'RESTRICTED' : level,
      scopeId,
      version,
    };
    const response = await apolloSdk.UpdateUserRole({ nodeId: accountId, input });
    const { errors, role } = response.updateUserRole;
    if (errors && errors.length > 0) {
      return Promise.reject(errors[0].message);
    }
    return commit(USER_ROLE_UPDATED, { userId, role });
  },
  async [INVITE_USER]({ rootState }, { email, level = 'USER', scopeId = null }) {
    const accountId = rootState[ACCOUNT].id;
    const input = {
      email: email.toLowerCase(),
      role: {
        scopeId,
        level: !scopeId ? level : 'RESTRICTED',
      },
      requirement: 'BASIC',
    };
    const response = await apolloSdk.Invite({ nodeId: accountId, input });
    const { errors, invite } = response.invite;
    if (errors && errors.length > 0) {
      return Promise.reject(errors[0].message);
    }
    return invite;
  },
  async [REVOKE_INVITE]({ rootState, commit }, { email }) {
    const accountId = rootState[ACCOUNT].id;
    const response = await apolloSdk.RevokeInvite({ nodeId: accountId, email });
    commit(INVITE_REVOKED, response.revokeInvite.invite.email);
  },
};

// mutations
const mutations = {
  [USERS_FETCHED](state, users) {
    state.users = users;
  },
  [INVITES_FETCHED](state, invites) {
    state.pendingInvites = invites;
  },
  [INVITE_REVOKED](state, revokedEmail) {
    state.pendingInvites = state.pendingInvites.filter(({ email }) => email !== revokedEmail);
  },
  [USER_REVOKED](state, userId) {
    state.users = state.users.filter(({ id }) => id !== userId);
  },
  [USER_ROLE_UPDATED](state, { userId, role }) {
    state.users = state.users.map((u) => {
      if (u.id !== userId) {
        return u;
      }
      const user = u;
      user.role = role;
      return user;
    });
  },
};

// initial state
const state = {
  users: [],
  pendingInvites: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
